module.exports = [
  {
    id: 'bancontact',
    name: 'Bancontact',
    description: 'Instant to 1 hour',
    icon: require('./icons/Bancontact'),
  },
  {
    id: 'creditCard',
    name: 'Credit/Debt card',
    description: 'Instant to 2 hours',
    icon: require('./icons/CreditCard'),
  },
  {
    id: 'bankTransfer',
    name: 'Manual bank transfer',
    description: '1-3 days',
    icon: require('./icons/ManualBankTransfer'),
  },
  {
    id: 'sofort',
    name: 'Sofort',
    description: 'Instant to 3 hours',
    icon: require('./icons/Sofort'),
  },
  {
    id: 'iDeal',
    name: 'Ideal',
    description: 'Instant to 1 hour',
    icon: require('./icons/Ideal'),
  },
  {
    id: 'giropay',
    name: 'GiroPay',
    description: 'Instant to 1 hour',
    icon: require('./icons/Giropay'),
  },
  {
    id: 'eps',
    name: 'EPS',
    description: 'Instant to 1 hour',
    icon: require('./icons/EPS'),
  },
];